const routes = {
  '/app/test': {
    fetch: () =>
      import(/* webpackChunkName: 'test-route' */ 'app/test/asyncRoute').then(
        module => module.default
      ),
  },
};

export default routes;
